import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { CommunicationAnalyticsActions } from './communication-analytics.actions';
import { AuthActions } from '@app/store/auth/auth.actions';
import { CommunicationAnalyticsApiService } from '@app/core/api/communication-analytics';
import { LoggerService } from '@app/core/infrastructure';

@Injectable()
export class CommunicationAnalyticsEffects {
  private readonly actions$ = inject(Actions);
  private readonly communicationApi = inject(CommunicationAnalyticsApiService);
  private readonly logger = inject(LoggerService).scope('CommunicationAnalyticsEffects');

  loadOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommunicationAnalyticsActions.loadOverview),
      switchMap(({ params }) =>
        this.communicationApi.getOverview(params).pipe(
          map(overview => CommunicationAnalyticsActions.loadOverviewSuccess({ overview })),
          catchError(error => {
            this.logger.error('Load communication overview failed:', error);
            return of(CommunicationAnalyticsActions.loadOverviewFailure({ error: error.message }));
          })
        )
      )
    )
  );

  loadTrend$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommunicationAnalyticsActions.loadTrend),
      switchMap(({ params }) =>
        this.communicationApi.getTrend(params).pipe(
          map(trend => CommunicationAnalyticsActions.loadTrendSuccess({ trend })),
          catchError(error => {
            this.logger.error('Load communication trend failed:', error);
            return of(CommunicationAnalyticsActions.loadTrendFailure({ error: error.message }));
          })
        )
      )
    )
  );

  loadTimePattern$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommunicationAnalyticsActions.loadTimePattern),
      switchMap(({ params }) =>
        this.communicationApi.getTimePattern(params).pipe(
          map(timePattern => CommunicationAnalyticsActions.loadTimePatternSuccess({ timePattern })),
          catchError(error => {
            this.logger.error('Load communication time pattern failed:', error);
            return of(CommunicationAnalyticsActions.loadTimePatternFailure({ error: error.message }));
          })
        )
      )
    )
  );

  clearOnLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),
      map(() => CommunicationAnalyticsActions.clearCommunicationAnalyticsState())
    )
  );
}
